module.exports = __webpack_public_path__ + "img/fashion_02.88ec98d6.jpg";